export default {
    ru: {
        mixed: {
            required: 'Это поле обязательно'
        },
        string: {
            email: 'Неверный формат email'
        }
    },
    en: {
        mixed: {
            required: 'Required field'
        },
        string: {
            email: 'Invalid email format'
        }
    }
};
